import "babel-polyfill"
import { app } from './app'

import "plugins/pace/pace-theme-flash"
import "plugins/bootstrapv3/css/bootstrap"
import "plugins/font-awesome/css/font-awesome"
import "plugins/jquery-scrollbar/jquery.scrollbar.css"
import "plugins/select2/css/select2.css"
import "plugins/switchery/css/switchery.min"
import "plugins/bootstrap-timepicker/bootstrap-timepicker.css"
import "assets/css/pages-icons"
import "plugins/dropzone/css/dropzone.css"
import "plugins/bootstrap-datepicker/css/datepicker3.css"
import "pages_sass/themes/corporate/corporate.scss"

import "plugins/pace/pace.min.js"
import "plugins/jquery/jquery-1.11.1.min.js"
import "plugins/modernizr.custom.js"
import "plugins/jquery-ui/jquery-ui.min.js"
import "plugins/bootstrapv3/js/bootstrap.min.js"
import "plugins/jquery/jquery-easy.js"
import "plugins/jquery-unveil/jquery.unveil.min.js"
import "plugins/jquery-bez/jquery.bez.min.js"
import "plugins/jquery-ios-list/jquery.ioslist.min.js"
import "plugins/imagesloaded/imagesloaded.pkgd.min.js"
import "plugins/jquery-actual/jquery.actual.min.js"
import "plugins/jquery-scrollbar/jquery.scrollbar.min.js"
import "plugins/classie/classie.js"
import "plugins/select2/js/select2.js"
import "plugins/interactjs/interact.min.js"
import "plugins/moment/moment-with-locales.min.js"
import "plugins/select2/js/select2.js"
import "pages_js/pages.calendar.js"
import "plugins/dropzone/dropzone.min.js"
import "plugins/bootstrap-datepicker/js/bootstrap-datepicker.js"
import "plugins/bootstrap-datepicker/js/locales/bootstrap-datepicker.fr.js"
import "plugins/bootstrap-timepicker/bootstrap-timepicker.js"
import "pages_js/pages"
import 'root/filters.js'

Pace.options.ajax.trackMethods = ['GET', 'POST', 'PUT', 'DELETE']
Pace.options.ajax.ignoreURLs = ['/notifications']

moment.locale('fr')

// Enable progressive web app support (with offline-plugin)
if (process.env.NODE_ENV === 'production') {
  require('./pwa')
}

app.$mount('#app')



// WEBPACK FOOTER //
// ./client/index.js